import { Component } from '@angular/core';
import { AuthService } from '../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { UserType } from '../../Shared/Enums/UserType';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { StatisticsService } from '../../Services/statistics.service';
import { CustomToastrService } from '../../Shared/Services/custom-toastr.service';
import { DtoStatisticsVM } from '../../Model/DtoStatisticsVM';
import { sparkchart } from '../../Shared/Models/sparkchart';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss'
})
export class StatisticsComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  spark1Chart!: Partial<sparkchart> | any;
  spark2Chart!: Partial<sparkchart> | any;
  spark3Chart!: Partial<sparkchart> | any;
  StatisticsInfo?: any;

  constructor(private router: Router, private auth: AuthService, private api: StatisticsService,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.intiCharts();
      this.GetStatistics();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  intiCharts() {
    // 1
    this.spark1Chart = {
      series: [
        {
          name: '',
          data: [4, 5, 2, 10, 9, 12, 4, 9],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#1e88e5'],
    };

    // 2
    this.spark2Chart = {
      series: [
        {
          name: '',
          data: [2, 5, 6, 10, 9, 12, 4, 9],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#f26f21'],
    };

    // 3
    this.spark3Chart = {
      series: [
        {
          name: '',
          data: [4, 5, 6, 10, 9, 12, 4, 9],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#ffb22b'],
    };
  }

  GetStatistics() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.api.GetStatistics(UserType.admin)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.StatisticsInfo = res.payload;
              this.SetChartData(res.payload);
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  SetChartData(res?: DtoStatisticsVM) {
    // 1
    this.spark1Chart = {
      series: [
        {
          name: '',
          data: [res?.numberOfAgents, res?.numberOfWorkShops, res?.numberOfClients],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#1e88e5'],
    };

    // 2
    this.spark2Chart = {
      series: [
        {
          name: '',
          data: [res?.numberOfAgents, res?.numberOfWorkShops, res?.numberOfClients],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#f26f21'],
    };

    // 3
    this.spark3Chart = {
      series: [
        {
          name: '',
          data: [res?.numberOfAgents, res?.numberOfWorkShops, res?.numberOfClients],
        },
      ],
      chart: {
        type: 'bar',
        height: 65,
        sparkline: { enabled: true }
      },
      colors: ['#ffb22b'],
    };
  }
}
